import React from 'react'

const renderComment = (path) => {
  return (path !== '/' && path !== '/courses' && path !== '/universities')
}
const Comments = ({path}) => {
  const url = process.env.URL || 'http://localhost:8000'
  if (renderComment(path)) {
    return <div key={path} className="fb-comments" data-href={`${url}/${path}`} data-width="500" data-numposts="10"></div>;
  }
  return <div/>
}

export default Comments;



// WEBPACK FOOTER //
// ./src/components/Comments/index.js